module.exports = __webpack_public_path__ + "static/me-0400ec95c6755bd077fff650bd8e32bc.svg";